<div class="appt-completion-modal">
  <div class="modal-header">
    <h2>Confirm Appointment Updates</h2>
  </div>
  
  <div class="modal-body">

    <p *ngIf="user">Current User: {{ user.first_name + ' ' + user.last_name }}</p>
    <p>You are about to change the status of <strong>{{data.apptCount}}</strong> record(s).</p>

    <div class="form-group">
      <label for="confirmationInput">Please enter your password to process:</label>
      <input 
        id="confirmationInput"
        type="password" 
        class="form-control" 
        [(ngModel)]="userPassword"
        placeholder="Enter password to continue"
      >
    </div>
  </div>
  
  <div class="modal-footer">
    <button 
      type="button" 
      class="btn btn-secondary" 
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button 
      type="button" 
      class="btn btn-primary" 
      (click)="onContinue()"
      [disabled]="!userPassword"
    >
      Continue
    </button>
  </div>
</div>
